import swordAsset from "@assets/weapons/sword/sword.fbx";
import swordHeroTextureAsset from "@assets/weapons/sword/sword_hero.png";
import staffAsset from "@assets/weapons/staff/staff.fbx";
import staffMageTextureAsset from "@assets/weapons/staff/staff_mage.png";
import daggerAsset from "@assets/weapons/dagger/dagger.fbx";
import daggerRogueTextureAsset from "@assets/weapons/dagger/dagger_rogue.png";

const WEAPON_SCALE = 100;

export const WeaponAssetMap = {
  sword: {
    unwrap: true,
    fileName: swordAsset,
    scale: WEAPON_SCALE,
  },
  swordHeroTexture: {
    fileName: swordHeroTextureAsset,
  },
  staff: {
    unwrap: true,
    fileName: staffAsset,
    scale: WEAPON_SCALE,
  },
  staffMageTexture: {
    fileName: staffMageTextureAsset,
  },
  dagger: {
    unwrap: true,
    fileName: daggerAsset,
    scale: WEAPON_SCALE,
  },
  daggerRogueTexture: {
    fileName: daggerRogueTextureAsset,
  },
} as const;
